import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function ProductListDialog({ open, onClose, title, products, type }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: type === 'top' ? '#F5D4BE' : '#D9F0EC',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 700,
        }}
      >
        {title}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        {products && products.length > 0 ? (
          <List>
            {products.map((product, index) => (
              <React.Fragment key={index}>
                <ListItem
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    py: 1.5,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {index + 1}. {product.ItemName}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#666' }}>
                      {product.Category}
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: 'right' }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      Qty: {product.TotalQuantity}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#4CAF50' }}>
                      ₹{parseFloat(product.TotalRevenue).toLocaleString()}
                    </Typography>
                  </Box>
                </ListItem>
                {index < products.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        ) : (
          <Typography variant="body2" sx={{ textAlign: 'center', py: 4, color: '#666' }}>
            No products found for the selected date range
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}
